import React from 'react';
import { CacheApiContext, CacheApiContextType, ServicesContext } from '~/services';
import { ReferralSelectOption } from '.';

interface MarketType {
    id: number;
    name: string;
    // eslint-disable-next-line babel/camelcase
    system_id: number;
    market: { id: number; name: string };
}

export function usePlanMarketList(): ReferralSelectOption[] {
    const services = React.useContext(ServicesContext);
    const { getCachedValue } = React.useContext(CacheApiContext) as CacheApiContextType;
    const [marketList, setMarketList] = React.useState([]);

    React.useEffect(() => {
        (async () => {
            // load markets
            const marketResult = await getCachedValue('core-app-plans', async () => {
                const result = await services.api.call({
                    method: 'get',
                    url: `/api/core-app-plans`,
                });
                return result.data['hydra:member']
                    .sort((a: MarketType, b: MarketType) => a.name.localeCompare(b.name))
                    .map((x: MarketType) => ({
                        value: x.system_id,
                        label: x.name,
                        marketId: x.market?.id,
                    }));
            });
            setMarketList(marketResult);
        })();
    }, [services, getCachedValue]);

    return marketList;
}
